import React, { useState, useEffect } from 'react';
import {
  fetchOrdenEstadoVentaApi,
  postAnularOrdenEstadoVentaApi,
  postAprobarOrdenEstadoVentaApi,
} from "../../../api/axios";
import { toast } from "react-toastify";

export default function EstadoVentaAdm({ idOrden, userId }) {
  const request = { idUsuario: userId, idVenta: idOrden };
  const [estadoVentaAprobado, setEstadoVentaAprobado] = useState(null);

  useEffect(() => {
    let req = fetchOrdenEstadoVentaApi(request);
    req.then(res => {
      setEstadoVentaAprobado(res.estado !== "Anulado");
    }).catch(err => {
      toast.warning("No se pudo obtener el estado interno");
    });
  }, []);

  const handleEstadoVenta = () => {
    let estadoVenta = estadoVentaAprobado
      ? postAnularOrdenEstadoVentaApi(request)
      : postAprobarOrdenEstadoVentaApi(request);

    estadoVenta.then(res => {
      setEstadoVentaAprobado(!estadoVentaAprobado);
      toast.success("Estado interno asignado");
    }).catch(err => {
      (err.response.data.errores) 
        ? err.response.data.errores.forEach(error => toast.error(error)) 
        : toast.warning("No se pudo actualizar el estado interno");
      setEstadoVentaAprobado(estadoVentaAprobado)
    });
  }

  return (
    <div className="row">
      <div className="col-12"><h6>Estado Interno</h6></div>

      <div className="col-12">
        <div className="row justify-content-center align-items-center">
          <div className="col-auto form-check form-switch">
            <input
              name="estadoVentaAprobado"
              type="checkbox"
              className="form-check-input d-inline"
              defaultChecked={estadoVentaAprobado}
              onClick={handleEstadoVenta}
            />
          </div>
          <div className="col-12 col-sm-auto">
            <label htmlFor="estadoVentaAprobado" className="custom-control-label d-inline col-auto">
              <span className={`label label-${estadoVentaAprobado ? "success" : "danger"}`}>
                {estadoVentaAprobado ? "Aprobado" : "Anulado"}
              </span>
            </label>
          </div>
        </div>
      </div>

    </div>
  )
}